import React from 'react'
import Link, { LINK_SIZES, LINK_TYPES } from 'components/Link'
import ResponsiveImage from 'components/ResponsiveImage'
import PropTypes from 'prop-types'

import './MarketInsightLatestListItem.scss'

const MarketInsightLatestListItem = ({ link, image, isRestricted, intro, publishedAt, publishedAtFormatted, publishedLabel }) => (
    <div className='market-insight-latest-list-item'>
        {image && 
            <ResponsiveImage
                {...image}
                fluid={true}
                className="market-insight-latest-list-item__image responsive-image_size_market-insight-latest-list-item"
            />
        }
        {link.text && (
            <Link
                text={link.text}
                url={link.url} 
                openInNewTab
                className='market-insight-latest-list-item__link'
                size={LINK_SIZES.large}
                type={
                    isRestricted
                        ? LINK_TYPES.restricted
                        : LINK_TYPES.regular
                }
            />
        )}
        {publishedAt && <time className='market-insight-latest-list-item__time' dateTime={publishedAt}>{publishedLabel}: {publishedAtFormatted}</time>}
        {intro && (
            <p className='market-insight-latest-list-item__intro'>{intro}</p>
        )}
    </div>
);

MarketInsightLatestListItem.propTypesMeta = {
    publishedLabel: 'exclude',
}

MarketInsightLatestListItem.propTypes = {
    intro: PropTypes.string,
    publishedAt: PropTypes.string,
    publishedAtFormatted: PropTypes.string,
    publishedLabel: PropTypes.string,
    link: PropTypes.exact(Link.propTypes).isRequired,
    image: PropTypes.exact(ResponsiveImage.propTypes),
    isRestricted: PropTypes.bool
}

export default MarketInsightLatestListItem;